export { default } from './BancoDoAuto25BlackBG';
